/* Pure, offline catalog and conservative serialized-state mapping. No runtime globals. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.ScCaseSelectorCore = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var own = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };
  function fail(code) { throw Object.assign(new Error(code), { code: code }); }
  function check(ok, code) { if (!ok) fail(code); }
  function record(o) { return o !== null && typeof o === 'object' && !Array.isArray(o); }
  function norm(s) { check(typeof s === 'string' && s.trim(), 'E_CATALOG_LABEL'); return s.trim().replace(/\s+/g, ' ').toLowerCase(); }
  function key(s) { return encodeURIComponent(norm(s).replace(/ /g, '-')); }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function stable(o) {
    if (Array.isArray(o)) return o.map(stable);
    if (!record(o)) return o;
    var out = {};
    Object.keys(o).sort().forEach(function (k) { Object.defineProperty(out, k, { value: stable(o[k]), enumerable: true }); });
    return out;
  }
  function equal(a, b) { return JSON.stringify(stable(a)) === JSON.stringify(stable(b)); }
  function id(v) { return (Number.isSafeInteger(v) && v >= 0) || (typeof v === 'string' && v.length > 0); }
  function index(items, getKey, code) {
    check(Array.isArray(items), code);
    var out = new Map();
    items.forEach(function (item) { check(record(item), code); var k = getKey(item); check(!out.has(k), code); out.set(k, item); });
    return out;
  }
  function one(items, predicate, code) { var matches = items.filter(predicate); check(matches.length === 1, code); return matches[0]; }
  function releaseShape(r) {
    check(record(r) && r.schemaName === 'sc-personalizer-release' && r.schemaVersion === '1.2.0', 'E_RELEASE_SCHEMA');
    check(record(r.product) && id(r.product.shopifyProductId) && record(r.identity) && typeof r.identity.releaseId === 'string', 'E_RELEASE_IDENTITY');
    check(record(r.selection) && Array.isArray(r.selection.optionSets) && Array.isArray(r.models) && Array.isArray(r.product.variants), 'E_RELEASE_SHAPE');
    index(r.selection.optionSets, function (s) { check(typeof s.id === 'string' && s.id.length > 0, 'E_OPTION_SET'); return s.id; }, 'E_OPTION_SET_AMBIGUOUS');
    r.selection.optionSets.forEach(function (s) {
      index(s.options, function (o) {
        check(id(o.id), 'E_OPTION_ID');
        ['values', 'functions', 'conditions', 'variation_conditions'].forEach(function (field) { check(o[field] === undefined || (Array.isArray(o[field]) && o[field].every(record)), 'E_OPTION_SCHEMA'); });
        return String(o.id);
      }, 'E_OPTION_AMBIGUOUS');
    });
    index(r.models, function (m) { return m.optionSetId; }, 'E_MODEL_SET');
    index(r.product.variants, function (v) { return String(v.variantId); }, 'E_VARIANT_AMBIGUOUS');
  }
  function modelSet(r, variant) {
    check(typeof variant.modelOptionSetId === 'string', 'E_MODEL_SET');
    var set = one(r.selection.optionSets, function (s) { return s.id === variant.modelOptionSetId && s.role === 'phone-model'; }, 'E_MODEL_SET');
    var model = one(r.models, function (m) { return m.optionSetId === set.id; }, 'E_MODEL_SET');
    check(id(model.optionId) && Array.isArray(model.values) && model.values.length > 0, 'E_MODEL_SET');
    one(set.options, function (o) { return o.id === model.optionId; }, 'E_MODEL_OPTION');
    index(model.values, function (v) { check(id(v.v), 'E_MODEL_VALUE'); return String(v.v); }, 'E_MODEL_VALUE');
    return model;
  }
  function buildCatalog(sources, options) {
    options = options || {};
    check(Array.isArray(sources) && sources.length > 0, 'E_CATALOG_SOURCES');
    var aliases = options.aliases || {}, disabled = options.disabled || [];
    check(record(aliases) && Array.isArray(disabled), 'E_CATALOG_OPTIONS');
    Object.keys(aliases).forEach(function (label) { norm(label); norm(aliases[label]); });
    var catalog = { version: 1, brands: [], caseTypes: [], models: [], sources: {} };
    var brands = new Map(), cases = new Map(), models = new Map(), sourceKeys = new Set();
    sources.forEach(function (source) {
      check(record(source) && typeof source.key === 'string' && /^[a-z][a-z0-9-]*$/.test(source.key) && !sourceKeys.has(source.key), 'E_CATALOG_SOURCE');
      sourceKeys.add(source.key);
      var r = source.release; releaseShape(r);
      check(typeof source.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(source.handle), 'E_CATALOG_HANDLE');
      check(typeof source.releaseUrl === 'string' && /^https:\/\/[^/?#@]+\/[^?#]+$/.test(source.releaseUrl), 'E_CATALOG_URL');
      check(record(source.cases) && Object.keys(source.cases).length > 0, 'E_CATALOG_CASES');
      Object.keys(source.cases).forEach(function (coordinate) {
        var c = source.cases[coordinate];
        check(record(c) && ['snap', 'tough', 'magsafe'].indexOf(c.key) !== -1, 'E_CATALOG_CASES'); norm(c.label);
        if (cases.has(c.key)) check(cases.get(c.key).label === c.label, 'E_CATALOG_CASE_AMBIGUOUS');
        else { var def = { key: c.key, label: c.label }; cases.set(c.key, def); catalog.caseTypes.push(def); }
      });
      catalog.sources[source.key] = { productId: r.product.shopifyProductId, handle: source.handle, releaseUrl: source.releaseUrl, identity: clone(r.identity) };
      var usedSets = new Set(), usedCases = new Set();
      r.product.variants.forEach(function (variant) {
        check(id(variant.variantId), 'E_VARIANT_ID');
        var coords = variant.coordinates;
        if (coords) check(record(coords) && Object.keys(coords).every(function (k) { return k === 'brand' || k === 'caseStyle'; }), 'E_VARIANT_COORDINATES');
        var coordinate = coords && coords.caseStyle != null ? coords.caseStyle : 'default';
        check(own(source.cases, coordinate), 'E_CATALOG_CASE_UNDECLARED');
        usedCases.add(coordinate);
        var c = source.cases[coordinate], label = coords ? coords.brand : variant.value;
        var brandKey = key(label), brand = brands.get(brandKey);
        if (!brand) { brand = { key: brandKey, label: label.trim().replace(/\s+/g, ' ') }; brands.set(brandKey, brand); catalog.brands.push(brand); }
        else check(norm(brand.label) === norm(label), 'E_CATALOG_BRAND_AMBIGUOUS');
        var m = modelSet(r, variant); usedSets.add(m.optionSetId);
        m.values.slice().sort(function (a, b) { return (a.sort || 0) - (b.sort || 0) || (String(a.v) < String(b.v) ? -1 : String(a.v) > String(b.v) ? 1 : 0); }).forEach(function (value) {
          var canonical = own(aliases, value.label) ? aliases[value.label] : value.label;
          var modelKey = brandKey + ':' + key(canonical), row = models.get(modelKey);
          if (!row) {
            row = { key: modelKey, brand: brandKey, label: canonical.trim().replace(/\s+/g, ' '), enabled: disabled.indexOf(modelKey) === -1, targets: {} };
            models.set(modelKey, row); catalog.models.push(row);
          } else check(norm(row.label) === norm(canonical), 'E_CATALOG_MODEL_AMBIGUOUS');
          check(!own(row.targets, c.key), 'E_CATALOG_TARGET_AMBIGUOUS');
          row.targets[c.key] = { sourceKey: source.key, productId: r.product.shopifyProductId, variantId: variant.variantId, model: { optionSetId: m.optionSetId, optionId: m.optionId, v: value.v } };
        });
      });
      check(r.models.every(function (m) { return usedSets.has(m.optionSetId); }) && usedSets.size === r.models.length, 'E_MODEL_SET_UNBOUND');
      check(r.selection.optionSets.filter(function (s) { return s.role === 'phone-model'; }).every(function (s) { return usedSets.has(s.id); }), 'E_MODEL_SET_UNBOUND');
      check(Object.keys(source.cases).every(function (c) { return usedCases.has(c); }), 'E_CATALOG_CASE_UNUSED');
    });
    disabled.forEach(function (k) { check(models.has(k), 'E_CATALOG_DISABLED_UNKNOWN'); });
    return catalog;
  }
  function resolve(catalog, modelKey, caseKey) {
    if (!catalog || catalog.version !== 1 || !catalog.caseTypes.some(function (c) { return c.key === caseKey; })) return null;
    var model = catalog.models.find(function (m) { return m.key === modelKey && m.enabled === true; });
    return model && own(model.targets, caseKey) ? model.targets[caseKey] : null;
  }
  function caseTypesFor(catalog, modelKey) {
    return (catalog && catalog.caseTypes || []).reduce(function (out, c) { var target = resolve(catalog, modelKey, c.key); if (target) out.push({ key: c.key, label: c.label, target: target }); return out; }, []);
  }

  var hasFn = function (o, type) { return (o.functions || []).some(function (f) { return f.type === type; }); };
  var mainSets = function (r) { return r.selection.optionSets.filter(function (s) { return s.role === 'main'; }); };
  var isArtwork = function (o) { return hasFn(o, 'image') && !hasFn(o, 'color') && !hasFn(o, 'product'); };
  var isSelect = function (o) { return ['Dropdown', 'Swatch'].indexOf(o.type) !== -1 && !(o.functions || []).length && Array.isArray(o.values) && o.values.length > 0; };
  var isCapture = function (o) { return o.type === 'Text Input' && !(o.functions || []).length && o.reachable !== false; };
  function optionKey(set, option) { return set.id + '/' + option.id; }
  // Only release-local UI asset references are omitted. Validation, source order, conditions,
  // functions, defaults, value identities, bindings, and even unknown properties must agree.
  function optionContract(o, templates, route) {
    var out = clone(o);
    if (out.values) out.values = out.values.map(function (v) {
      delete v.thumbAssetRef; delete v.thumbPreferredAssetRef;
      if (templates && (hasFn(o, 'product') || route)) delete v.product_id;
      return v;
    });
    return out;
  }
  function templateOptions(r) {
    return mainSets(r).flatMap(function (s) { return s.options.filter(function (o) { return hasFn(o, 'product'); }); });
  }
  // Partitioned template authority (mirrors runtime pz-rules templateAuthority): >1 template
  // selector, each shown by exactly one route value of ONE pure/image route option in a main
  // set, e.g. sc71512p2 "Number Of Children" -> 5 x "Number Of Grandkids". Route values may own
  // templates themselves. The route answer is a durable state coordinate (selectedValueByOption).
  function templateRoute(r, selectors) {
    if (selectors.length < 2) return null;
    var watched = selectors.map(function (o) {
      var c = o.conditions || [];
      check(Array.isArray(o.values) && o.values.length > 0 && !(o.variation_conditions || []).length && c.length === 1 && record(c[0]) && c[0].action === 'show' && Array.isArray(c[0].desired_value) && c[0].desired_value.length === 1, 'E_TEMPLATE_SCHEMA');
      return c[0];
    });
    check(watched.every(function (c) { return c.watch_option === watched[0].watch_option; }), 'E_TEMPLATE_SCHEMA');
    var set = one(mainSets(r), function (s) { return s.options.some(function (o) { return o.id === watched[0].watch_option; }); }, 'E_TEMPLATE_SCHEMA');
    var route = one(set.options, function (o) { return o.id === watched[0].watch_option; }, 'E_TEMPLATE_SCHEMA');
    check(!hasFn(route, 'product') && (route.functions || []).every(function (f) { return f.type === 'image'; }) && Array.isArray(route.values) && route.values.length > 0, 'E_TEMPLATE_SCHEMA');
    // Every route value opens exactly one branch; no branch watches a value the route lacks.
    var branches = watched.map(function (c) { return String(c.desired_value[0]); });
    check(new Set(branches).size === branches.length && branches.length === route.values.length && route.values.every(function (v) { return branches.indexOf(String(v.id)) !== -1; }), 'E_TEMPLATE_SCHEMA');
    return { key: optionKey(set, route), option: route };
  }
  function compatibility(a, b) {
    releaseShape(a); releaseShape(b);
    [a, b].forEach(function (r) {
      check(Object.keys(r.selection).every(function (k) { return ['initialTemplate', 'mainOptionSetId', 'optionSets'].indexOf(k) !== -1; }), 'E_SELECTION_SCHEMA');
      one(r.selection.optionSets, function (s) { return s.role === 'main' && s.id === r.selection.mainOptionSetId; }, 'E_MAIN_NAMESPACE');
      check(!r.product.variantTemplateMap && !r.product.templateByVariant, 'E_TEMPLATE_SCHEMA');
      check(r.selection.optionSets.every(function (s) { return s.role === 'main' || s.role === 'phone-model'; }), 'E_OPTION_ROLE');
    });
    var ao = templateOptions(a), bo = templateOptions(b), templates = new Map();
    var ar = templateRoute(a, ao), br = templateRoute(b, bo);
    var am = mainSets(a), bm = mainSets(b), keys = new Map();
    check(am.length > 0 && am.length === bm.length, 'E_MAIN_CONTRACT');
    am.forEach(function (s, i) {
      var t = bm[i];
      check(s.id === a.selection.mainOptionSetId ? t.id === b.selection.mainOptionSetId : s.id === t.id, 'E_MAIN_NAMESPACE');
      var setContract = function (set) { var c = clone(set); delete c.id; delete c.title; delete c.options; return c; };
      check(equal(setContract(s), setContract(t)), 'E_MAIN_CONTRACT');
      var targetOptions = index(t.options, function (o) { return String(o.id); }, 'E_MAIN_CONTRACT');
      check(s.options.length === t.options.length, 'E_MAIN_CONTRACT');
      s.options.forEach(function (o) {
        var to = targetOptions.get(String(o.id));
        var routeA = !!ar && o === ar.option, routeB = !!br && !!to && to === br.option;
        check(to && routeA === routeB && equal(optionContract(o, true, routeA), optionContract(to, true, routeB)), 'E_MAIN_CONTRACT');
        keys.set(optionKey(s, o), { key: optionKey(t, to), source: o, target: to });
      });
    });
    // Pilot: one unconditional selector over every template. Partitioned: see templateRoute().
    check(ao.length === bo.length && (ar ? !!br : ao.length === 1 && !(ao[0].conditions || []).length && !(bo[0].conditions || []).length), 'E_TEMPLATE_SCHEMA');
    var at = index(a.templates, function (t) { return t.templateUuid; }, 'E_TEMPLATE_SCHEMA');
    var bt = index(b.templates, function (t) { return t.templateUuid; }, 'E_TEMPLATE_SCHEMA');
    if (!ar) check(Array.isArray(ao[0].values) && Array.isArray(bo[0].values) && ao[0].values.length === at.size && bo[0].values.length === bt.size, 'E_TEMPLATE_SCHEMA');
    [at, bt].forEach(function (map) { map.forEach(function (t) { check(Array.isArray(t.layers) && t.layers.every(record), 'E_TEMPLATE_SCHEMA'); }); });
    var textIds = function (t) { return t.layers.filter(function (l) { return l.k === 'text'; }).map(function (l) { return String(l.id); }).sort(); };
    // Selectors pair by option id (contracts already equal); a shared template maps consistently.
    var pairs = ao.map(function (o) { return [o, one(bo, function (x) { return x.id === o.id; }, 'E_TEMPLATE_MAPPING')]; });
    if (ar) pairs.push([ar.option, br.option]);
    pairs.forEach(function (pair) {
      check(Array.isArray(pair[0].values) && Array.isArray(pair[1].values) && pair[0].values.length === pair[1].values.length, 'E_TEMPLATE_SCHEMA');
      pair[0].values.forEach(function (v) {
        var tv = one(pair[1].values, function (x) { return x.value === v.value && x.id === v.id; }, 'E_TEMPLATE_MAPPING');
        if (pair[0] === (ar && ar.option) && (v.product_id == null || v.product_id === '')) { check(tv.product_id == null || tv.product_id === '', 'E_TEMPLATE_MAPPING'); return; }
        check(at.has(v.product_id) && bt.has(tv.product_id), 'E_TEMPLATE_MAPPING');
        if (templates.has(v.product_id)) { check(!!ar && templates.get(v.product_id) === tv.product_id, 'E_TEMPLATE_MAPPING'); return; }
        check(equal(textIds(at.get(v.product_id)), textIds(bt.get(tv.product_id))), 'E_TEXT_CONTRACT');
        templates.set(v.product_id, tv.product_id);
      });
    });
    check(new Set(templates.values()).size === templates.size && at.has(a.selection.initialTemplate) && bt.has(b.selection.initialTemplate), 'E_TEMPLATE_MAPPING');
    // Runtime opens on a selector path: a route-owned template can never be the landing template.
    var selectable = new Set(ao.flatMap(function (o) { return o.values.map(function (v) { return v.product_id; }); }));
    if (ar) check(templates.size === at.size && at.size === bt.size && selectable.has(a.selection.initialTemplate) && templates.get(a.selection.initialTemplate) === b.selection.initialTemplate, 'E_TEMPLATE_MAPPING');
    var backgrounds = new Map();
    check(Array.isArray(a.backgrounds) && Array.isArray(b.backgrounds) && a.backgrounds.length === b.backgrounds.length, 'E_BACKGROUND_CONTRACT');
    index(a.backgrounds, function (v) { return String(v.id); }, 'E_BACKGROUND_CONTRACT');
    index(b.backgrounds, function (v) { return String(v.id); }, 'E_BACKGROUND_CONTRACT');
    a.backgrounds.forEach(function (v) {
      var tv = one(b.backgrounds, function (x) { return x.value === v.value; }, 'E_BACKGROUND_CONTRACT');
      check(v.pos === tv.pos && v.colorPos === tv.colorPos, 'E_BACKGROUND_CONTRACT');
      backgrounds.set(String(v.id), tv.id);
    });
    return { keys: keys, templates: templates, backgrounds: backgrounds, route: ar ? ar.key : null };
  }
  function assertCompatible(a, b) { compatibility(a, b); return true; }
  function nativeSelection(r, variantId, model) {
    check(record(model) && Object.keys(model).sort().join(',') === 'optionId,optionSetId,v', 'E_STATE_MODEL');
    var variant = one(r.product.variants, function (v) { return v.variantId === variantId; }, 'E_STATE_VARIANT');
    var set = modelSet(r, variant);
    check(model.optionSetId === set.optionSetId && model.optionId === set.optionId, 'E_STATE_MODEL');
    one(set.values, function (v) { return v.v === model.v; }, 'E_STATE_MODEL');
    return variant;
  }
  function allOptions(r) {
    var out = new Map();
    r.selection.optionSets.forEach(function (s) { s.options.forEach(function (o) { out.set(optionKey(s, o), { set: s, option: o }); }); });
    return out;
  }
  function choice(o, v) { return one(o.values || [], function (x) { return x.id === v; }, 'E_STATE_CHOICE'); }
  function surface(o) { return o.label === 'Surface' && o.type === 'Dropdown' && isSelect(o); }
  function legacyMagsafe(o) {
    var f = o.functions || [];
    return o.type === 'Checkbox' && f.length === 1 && f[0].type === 'shProduct' && Array.isArray(f[0].shProducts) && f[0].shProducts.length === 1 && f[0].shProducts[0].handle === 'make-it-magsafe';
  }
  function shownSurface(o, model) {
    check(!(o.variation_conditions || []).length && (o.conditions || []).length <= 1, 'E_SURFACE_SCHEMA');
    if (o.reachable === false) return false;
    return (o.conditions || []).every(function (c) {
      check(c.action === 'show' && c.watch_option === model.optionId && Array.isArray(c.desired_value), 'E_SURFACE_SCHEMA');
      return c.desired_value.indexOf(model.v) !== -1;
    });
  }
  function mapSelection(sourceRelease, targetRelease, serialized, target) {
    var plan = compatibility(sourceRelease, targetRelease), p = serialized;
    check(record(p) && [1, 2, 3].indexOf(p.v) !== -1, 'E_STATE_VERSION');
    check(Object.keys(p).every(function (k) { return ['v', 'brandVariantId', 'model', 'templateUuid', 'backgroundId', 'selectedValueByOption', 'texts', 'captures', 'selects', 'uploads', 'addons'].indexOf(k) !== -1; }), 'E_STATE_FIELD');
    nativeSelection(sourceRelease, p.brandVariantId, p.model);
    check(record(target) && target.productId === targetRelease.product.shopifyProductId, 'E_TARGET_PRODUCT');
    nativeSelection(targetRelease, target.variantId, target.model);
    check(plan.templates.has(p.templateUuid), 'E_STATE_TEMPLATE');
    check(p.backgroundId === null || plan.backgrounds.has(String(p.backgroundId)), 'E_STATE_BACKGROUND');
    var out = { v: p.v, brandVariantId: target.variantId, model: clone(target.model), templateUuid: plan.templates.get(p.templateUuid), backgroundId: p.backgroundId === null ? null : plan.backgrounds.get(String(p.backgroundId)) };
    var sourceOptions = allOptions(sourceRelease), targetOptions = allOptions(targetRelease), activeSurface = null;
    ['selectedValueByOption', 'texts', 'captures', 'selects', 'uploads', 'addons'].forEach(function (field) {
      if (!own(p, field)) { check(field !== 'selectedValueByOption' || p.v === 1, 'E_STATE_SHAPE'); return; }
      check(record(p[field]), 'E_STATE_SHAPE');
      out[field] = {};
      Object.keys(p[field]).forEach(function (k) {
        var value = p[field][k];
        if (field === 'texts') {
          check(typeof value === 'string' && sourceRelease.templates.some(function (t) { return t.layers.some(function (l) { return l.k === 'text' && String(l.id) === k; }); }), 'E_STATE_TEXT');
          out[field][k] = value; return;
        }
        if (field === 'captures') {
          var captures = Array.from(plan.keys.values()).filter(function (m) { return String(m.source.id) === k && isCapture(m.source); });
          check(captures.length === 1 && typeof value === 'string', 'E_STATE_CAPTURE');
          check(captures[0].source.max_length == null || value.length <= captures[0].source.max_length, 'E_STATE_CAPTURE');
          out[field][String(captures[0].target.id)] = value; return;
        }
        var entry = sourceOptions.get(k); check(entry, 'E_STATE_OPTION');
        var o = entry.option, mapping = plan.keys.get(k);
        if (field === 'addons') {
          check(typeof value === 'boolean', 'E_STATE_ADDON');
          if (entry.set.role === 'phone-model' && legacyMagsafe(o)) return;
          check(mapping && o.type === 'Checkbox' && hasFn(o, 'shProduct'), 'E_STATE_ADDON');
        } else if (field === 'selects') {
          check(isSelect(o), 'E_STATE_CHOICE'); var picked = choice(o, value);
          if (entry.set.role === 'phone-model') {
            check(surface(o), 'E_STATE_PHONE_FIELD');
            // Retain dormant native Surface picks where their namespace still exists.
            var retained = targetOptions.get(k);
            if (retained && equal(optionContract(o), optionContract(retained.option))) out[field][k] = value;
            if (entry.set.id === p.model.optionSetId && shownSurface(o, p.model)) {
              var candidates = Array.from(targetOptions.entries()).filter(function (pair) { return pair[1].set.id === target.model.optionSetId && surface(pair[1].option) && shownSurface(pair[1].option, target.model); });
              check(candidates.length <= 1, 'E_SURFACE_AMBIGUOUS');
              if (candidates.length) {
                var dest = candidates[0], values = dest[1].option.values.filter(function (v) { return v.value === picked.value; });
                check(values.length <= 1, 'E_SURFACE_AMBIGUOUS');
                if (values.length) { check(activeSurface === null, 'E_SURFACE_AMBIGUOUS'); activeSurface = { key: dest[0], value: values[0].id }; }
              }
            }
            return;
          }
        } else if (field === 'selectedValueByOption') {
          check(isArtwork(o) || k === plan.route, 'E_STATE_ARTWORK'); choice(o, value);
        } else if (field === 'uploads') {
          check(o.type === 'Image Upload' && !(o.functions || []).length && o.reachable !== false && record(value), 'E_STATE_UPLOAD');
        }
        check(mapping, 'E_STATE_NAMESPACE');
        out[field][mapping.key] = clone(value);
      });
    });
    if (p.v >= 2) {
      var expected = Array.from(plan.keys.entries()).filter(function (pair) { return isArtwork(pair[1].source) || pair[0] === plan.route; }).map(function (pair) { return pair[0]; }).sort();
      check(equal(Object.keys(p.selectedValueByOption).sort(), expected), 'E_STATE_ARTWORK');
    }
    // The active source answer beats a dormant destination pick, regardless of object key order.
    if (activeSurface) out.selects[activeSurface.key] = activeSurface.value;
    // Explicit false prevents a startSelected legacy checkbox from being restored as an upsell.
    targetOptions.forEach(function (entry, k) {
      if (entry.set.role === 'phone-model' && legacyMagsafe(entry.option)) { if (!out.addons) out.addons = {}; out.addons[k] = false; }
    });
    return out;
  }
  return { buildCatalog: buildCatalog, resolve: resolve, caseTypesFor: caseTypesFor, mapSelection: mapSelection, assertCompatible: assertCompatible };
}));
